<template>
    <div class="current-amount">
        <span class="text">Wybrana kwota:</span>
        <span class="amount">{{ amount }} zł</span>
    </div>
</template>

<script>
export default {
    name: 'CurrentAmount',
    props: {
        amount: {
            required: true,
        }
    }
}
</script>
